__turbopack_context__.v({
  "text": "TextBlock-module__VsrOWW__text",
  "title": "TextBlock-module__VsrOWW__title",
});
